module.exports = __webpack_public_path__ + "img/303.a60d54e7.png";